import { Avatar, Button, Divider, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useRef } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import ProfilePic from "../../../../Asssets/Images/profile.png";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../Utils/Loader";
import { errorNotify, successNotify } from "../../../../Utils/toast";
import { useStyle } from "../LeaveManagement/leaveStyles";
import { MdOutlineWatchLater } from "react-icons/md";
import { SiRocketdotchat } from "react-icons/si";
import { getCurrentUser } from "../../../../Redux/Actions/Auth";
import {
  getPettyPurchaseDetail,
  sendPettyPurchaseComment,
} from "../../../../Redux/Actions/PettyPurchases";
import moment from "moment";
import { BaseURL } from "../../../../Utils/interceptors";
import { getToken } from "../../../../Utils/helper";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "../../../../Components/Header/Header";
import { FaPrint } from "react-icons/fa";
import { useReactToPrint } from "react-to-print";

const PettyPurchaseDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const classes = useStyle();
  const printRef = useRef();
  const [commentSent, setCommentSent] = useState(false);
  const [comment, setComment] = useState("");
  const [commentLoading, setCommentLoading] = useState(false);
  const { loading, purchase } = useSelector(
    (state) => state.pettyPurchaseDetails
  );
  const { user } = useSelector((state) => state.currentUser);
  const [updateLoading, setUpdateLoading] = useState(false);
  const { id } = useParams();

  // Check if user has access to this module (moved up to avoid TDZ in hooks)
  const hasAccess =
    (user?.user?.department?._id === "68875ce1f9c0eda4dcce9c74" ||
      user?.user?.department?._id === "6392e6b4758449db0ae81600" ||
      user?.user?.department?._id === "63d8c6158c662fd4d455ce85" ||
      user?.user?.department?._id === "6698ff124aa01ad1714d88b3") &&
    (user?.user?.role === "HR" ||
      user?.user?.role === "admin" ||
      user?.user?.role === "employee");

  useEffect(() => {
    if (!hasAccess) {
      navigate("/HR/dashboard");
      return;
    }

    dispatch(getPettyPurchaseDetail(id));
  }, [id, hasAccess, navigate, commentSent]);

  // Hide elements in print
  const printStyles = `
  @media print {
    .no-print { display: none !important; }
    .print-table-row {
      display: flex !important;
      flex-direction: row !important;
      align-items: flex-start !important;
      margin-bottom: 0 !important;
    }
    .print-table-col {
      flex: 1 1 0;
      padding: 0 8px;
      min-width: 0;
      box-sizing: border-box;
    }
    .print-table-label {
      font-weight: bold !important;
      font-size: 16px !important;
      color: #253766 !important;
      margin-bottom: 2px !important;
    }
    .print-table-value {
      font-size: 15px !important;
      color: #222 !important;
    }
    .print-table-row + .print-table-row {
      margin-top: 8px !important;
    }
  }
`;

  // Normalize payload shape from API/reducer
  const pr = purchase?.pettyPurchase;

  // Splitting the name in detail page
  var space = pr?.request_by?.full_name?.indexOf(" ");
  const firstname = pr?.request_by?.full_name?.substring(0, space);

  const updateHandler = async (status, approverType) => {
    const url = `${BaseURL}/petty-purchase/confirmation/${pr?._id}`;
    const token = getToken();
    const options = {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    };
    try {
      setUpdateLoading(true);
      const res = await axios.put(url, { status, approverType }, options);
      if (res !== undefined) {
        toast.success(res?.data?.message);
        dispatch(getPettyPurchaseDetail(id));
      }
      setUpdateLoading(false);
    } catch (err) {
      console.log(err);
      setUpdateLoading(false);
    }
  };

  const handleSendComment = async () => {
    if (!comment.trim()) return;

    try {
      setCommentLoading(true);
      dispatch(sendPettyPurchaseComment(id, comment));
      setComment("");
      dispatch(getPettyPurchaseDetail(id));
      setCommentLoading(false);
      toast.success("Comment sent successfully!");
      setCommentSent(!commentSent); // Toggle commentSent to re-render
    } catch (err) {
      setCommentLoading(false);
      toast.error("Failed to send comment. Please try again.");
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // hasAccess is defined above

  // If user doesn't have access, show access denied message
  if (!hasAccess) {
    return (
      <div className="page_responsive">
        <Header title="Access Denied" />
        <div className="text-center mt-5">
          <h3 style={{ color: "#dc3545" }}>Access Denied</h3>
          <p>You don't have permission to access the Petty Purchase module.</p>
          <p>
            <strong>Required Department:</strong> Accounts
          </p>
          <p>
            <strong>Required Role:</strong> HR, Admin, or Employee
          </p>
          <p>
            <strong>Your Department:</strong>{" "}
            {user?.user?.department_name || "Unknown"}
          </p>
          <p>
            <strong>Your Role:</strong> {user?.user?.role || "Unknown"}
          </p>
          <p>
            Please contact your administrator if you believe this is an error.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="page_responsive">
      <Header title="Petty Purchase Order Details" />
      {/* Print button at the top, like Payslip */}
      <div className="d-flex justify-content-end mx-4 mb-3 mt-3">
        <Button
          variant="outlined"
          onClick={handlePrint}
          startIcon={<FaPrint />}
        >
          Print Order
        </Button>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div ref={printRef}>
          <Row className="justify-content-center">
            <Col md={7}>
              <Box className="my-2 ms-4">
                <Paper className={classes.sectionsContainer}>
                  <Box className={classes.sectionHeader}>
                    Petty Purchase Order - {pr?.item_name || "N/A"}
                  </Box>
                  <Box className="mx-3">
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      className="my-3"
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px" }}
                      >
                        <Avatar
                          sx={{ width: "50px", height: "50px" }}
                          src={
                            pr?.request_by?.profile_picture
                              ? pr?.request_by?.profile_picture[0]?.fileName
                              : ProfilePic
                          }
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#253766",
                          }}
                        >
                          {pr?.request_by?.full_name}
                        </Typography>
                      </div>

                      <div className="created_at_container">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <MdOutlineWatchLater
                            style={{
                              fontSize: "23px",
                              marginRight: "3px",
                              color: "#0097d9",
                            }}
                          />{" "}
                          <div>
                            <h6
                              className="mb-1"
                              style={{ color: "#0097d9", fontWeight: "500" }}
                            >
                              Created At{" "}
                            </h6>
                            <h6 style={{ fontSize: "14px" }}>
                              {moment(pr?.createdAt || pr?.request_date).format(
                                "DD-MM-YYYY"
                              )}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </Box>
                  <Box className={`mx-3 ${classes.leaveDetails}`}>
                    {/* Product Code on first line */}
                    <Row className="mt-4 mb-2">
                      <Col md={12}>
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                            display: "inline",
                          }}
                        >
                          Product Code:
                        </div>
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: 16,
                            color: "#222",
                            marginLeft: 8,
                          }}
                        >
                          {pr?.product_code || "N/A"}
                        </span>
                      </Col>
                    </Row>
                    {/* 2 fields per line */}
                    <Row className="my-3 print-table-row">
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Item Name
                        </div>
                        <div className="print-table-value">{pr?.item_name}</div>
                      </Col>
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Quantity
                        </div>
                        <div className="print-table-value">{pr?.quantity}</div>
                      </Col>
                    </Row>
                    <Row className="my-3 print-table-row">
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Last Purchased Date
                        </div>
                        <div className="print-table-value">
                          {pr?.last_purchase_date
                            ? moment(pr?.last_purchase_date).format(
                                "DD-MM-YYYY"
                              )
                            : "N/A"}
                        </div>
                      </Col>
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Item Last Price
                        </div>
                        <div className="print-table-value">
                          {pr?.item_last_price ?? "N/A"}
                        </div>
                      </Col>
                    </Row>
                    <Row className="my-3 print-table-row">
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Estimated Unit Cost
                        </div>
                        <div className="print-table-value">
                          {pr?.estimated_unit_cost ?? "N/A"}
                        </div>
                      </Col>
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Estimated Total Cost
                        </div>
                        <div className="print-table-value">
                          {pr?.estimated_total_cost ?? "N/A"}
                        </div>
                      </Col>
                    </Row>
                    {/* Vendor Details and Description, one per line */}
                    <Row className="my-3 print-table-row">
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Required By Date
                        </div>
                        <div className="print-table-value">
                          {pr?.required_by_date
                            ? moment(pr?.required_by_date).format("DD-MM-YYYY")
                            : "N/A"}
                        </div>
                      </Col>
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Priority
                        </div>
                        <div
                          className="print-table-value"
                          style={{ textTransform: "capitalize" }}
                        >
                          {pr?.priority}
                        </div>
                      </Col>
                    </Row>
                    <Row className="my-3 print-table-row">
                      <Col md={12} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Vendor Details
                        </div>
                        <div className="print-table-value">
                          {pr?.vendor_details || "N/A"}
                        </div>
                      </Col>
                    </Row>
                    <Row className="my-3 print-table-row">
                      <Col md={12} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Description
                        </div>
                        <div className="print-table-value">
                          {pr?.description}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-3 print-table-row">
                      <Col md={6} className="print-table-col">
                        <div
                          className="print-table-label"
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            color: "#253766",
                          }}
                        >
                          Accounts Status
                        </div>
                        <Box
                          className={
                            pr?.accounts_status === "pending"
                              ? classes.pending
                              : pr?.accounts_status === "approved"
                              ? classes.approved
                              : classes.rejected
                          }
                        >
                          {pr?.accounts_status}
                        </Box>
                      </Col>
                      <Col md={12}>
                        {user?.user?.department?._id ===
                          "68875ce1f9c0eda4dcce9c74" &&
                          pr?.accounts_status === "pending" && (
                            <div className="d-flex gap-2 mt-3 no-print justify-content-end">
                              <Button
                                onClick={() =>
                                  updateHandler("approved", "department")
                                }
                                variant="contained"
                                className={classes.approvedBtn}
                                disabled={updateLoading}
                              >
                                {updateLoading ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  "Approve"
                                )}
                              </Button>
                              <Button
                                onClick={() =>
                                  updateHandler("rejected", "department")
                                }
                                variant="contained"
                                className={classes.rejectedBtn}
                                disabled={updateLoading}
                              >
                                {updateLoading ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  "Reject"
                                )}
                              </Button>
                            </div>
                          )}
                      </Col>
                    </Row>
                  </Box>
                </Paper>
              </Box>
            </Col>
            <Col md={5}>
              <Box className="my-2 me-4">
                {/* Documents section: visible on screen, hidden in print */}
                <style>{printStyles}</style>
                <Paper className={classes.sectionsContainer + " no-print"}>
                  <Box className={classes.sectionHeader}>Documents</Box>
                  <Row>
                    {pr?.petty_purchase_docs &&
                    pr?.petty_purchase_docs.length !== 0 ? (
                      pr?.petty_purchase_docs.map((d, index) => (
                        <Col
                          md={6}
                          className="d-flex justify-content-center"
                          key={index}
                        >
                          <Box className={classes.documents_container}>
                            <Box
                              sx={{
                                display: "flex",
                                width: "100%",
                                position: "relative",
                              }}
                            >
                              <a
                                href={d?.url}
                                target="_blank"
                                style={{
                                  width: "100%",
                                  height: "200px",
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                }}
                              />

                              {d?.url.includes(".pdf") && (
                                <iframe
                                  src={d?.url}
                                  width="100%"
                                  height="100px"
                                />
                              )}
                              {(d?.url.includes(".png") ||
                                d?.url.includes(".jpg") ||
                                d?.url.includes(".jpeg")) && (
                                <img
                                  src={d?.url}
                                  style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    height: "100px",
                                  }}
                                />
                              )}
                            </Box>
                          </Box>
                        </Col>
                      ))
                    ) : (
                      <Typography variant="h6" className="text-center mt-3">
                        {" "}
                        No Documents submitted!
                      </Typography>
                    )}
                  </Row>
                </Paper>
              </Box>
            </Col>

            <Col md={12}>
              <Box className="my-2 mx-4">
                <Paper className={classes.sectionsContainer}>
                  <Box className={classes.sectionHeader}>
                    <SiRocketdotchat /> Chat
                  </Box>
                  <Box sx={{ p: 2 }}>
                    {pr?.conversation && pr?.conversation?.length !== 0 ? (
                      pr?.conversation?.map((d, index) => (
                        <Box
                          sx={{ pb: 2, display: "flex", gap: "10px" }}
                          key={index}
                        >
                          <Avatar
                            sx={{
                              width: "55px",
                              height: "55px",
                              mr: 1,
                              objectFit: "contain",
                            }}
                            src={d?.user?.profile_picture[0]?.fileName}
                          />
                          <Box sx={{ width: "100%" }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                                width: "100%",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "600",
                                  fontSize: "16px",
                                  color: "#253766",
                                }}
                              >
                                {d?.user?.full_name}
                              </Typography>

                              <Typography
                                sx={{ fontWeight: "500", fontSize: "14px" }}
                              >
                                {new Date(d?.created).toLocaleString("en-GB")}
                              </Typography>
                            </Box>
                            <Typography
                              sx={{
                                fontWeight: "500",
                                fontSize: "14px",
                                backgroundColor: "#ebf4f7",
                                padding: "10px 10px",
                              }}
                            >
                              {d?.comment}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="h6" className="mt-3">
                        {" "}
                        No Previous comment found!
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ p: 2 }} className="no-print">
                    <Box sx={{ position: "relative" }}>
                      <input
                        placeholder="Type a message"
                        style={{
                          width: "100%",
                          padding: "20px 110px 40px 20px",
                          border: "1px solid #d6eff7",
                        }}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <button
                        style={{
                          position: "absolute",
                          right: "20px",
                          top: "26%",
                        }}
                        className={classes.sendBtn}
                        onClick={handleSendComment}
                        disabled={commentLoading}
                      >
                        {commentLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Send"
                        )}
                      </button>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            </Col>
          </Row>
        </div>
      )}

      {/* Print button moved to top, removed from bottom */}
    </div>
  );
};

export default PettyPurchaseDetails;
